import { Component, ElementRef, EventEmitter,  OnInit, Output, ViewChild } from '@angular/core';
import { CommonService, PageService, SpinnerService } from 'src/app/services/service.index';
import { environment } from 'src/environments/environment.prod';
import { ColorAdjustmentUtils } from '../../utilities/color-adjustment.utils';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GlobalInfoService } from 'src/app/services/shared/global-info.service';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { UserModel } from 'src/app/models/auth/_models/user.model';
import { Observable } from 'rxjs';
import { Page } from 'src/app/models/page.model';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @Output() close = new EventEmitter<any>();
  isDropdownOpen = false; 
  isSubmenuOpen = false;
  submenuOpen = false;
  tokenOph: any;
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  user$: Observable<UserModel>;   
  textModal:string='';
  titleModal:string='';
  modalRef: NgbModalRef;
  @ViewChild("politicasModal") politicasModal: ElementRef;
  token: string;
  company: any;
  username: any;
  constructor(private microapps: MicroapplicationService,private mainHTTPService:MainHTTPService,private _spinnerService: SpinnerService, private auth: AuthService,private _commonService: CommonService, private _pageService: PageService, private elRef: ElementRef, private modalService: NgbModal, private GlobalInfoService:GlobalInfoService) { }

  version: string = '';

  ngOnInit(): void {

    this.user$ = this.auth.currentUserSubject.asObservable();
    this.company = this.sessionData.selectedCompany.code;
    this.username = this.sessionData.username;


    document.addEventListener('click', this.handleDocumentClick);
    this.version = environment.appVersion;
    const defaultSecondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();
    const darkenColor = 0.08; // Ejemplo de valor de ajuste
    const adjustedColor = ColorAdjustmentUtils.adjustColorDarkness(defaultSecondaryColor, darkenColor);
    
    // Asignar el valor a --secondary-color-adjusted en lugar de --secondary-color
    document.documentElement.style.setProperty('--secondary-color-adjusted', adjustedColor);
  }

  ngOnDestroy() { 
    document.removeEventListener('click', this.handleDocumentClick); 
  }

  handleDocumentClick = (event: MouseEvent) => { 
    if (!this.elRef.nativeElement.contains(event.target)) { 
      this.submenuOpen = false; 
    } 
  } 

  // @HostListener('click', ['$event.target'])
  // toggleSubmenu() { 
  //   this.submenuOpen = !this.submenuOpen; 
  // }

  stopPropagation(event: Event) {
    event.stopPropagation(); 
  }

  toggle() {
    document.getElementById('side-arrow')?.classList.toggle('sdActiveArrow');
  }

  // cerrarOph() {
  //   const requestMenu = JSON.parse(this._commonService.getItemsessionStorage('requestMenu') || '{}');
  //   this.tokenOph = requestMenu.usuario;
  //   this._pageService.DeleteListpageOphGeneral(this.tokenOph).subscribe((data: any) => {
  //   })
  // }
  openModal(tittle:string){
    this.titleModal=tittle;
    this.textModal = tittle=='Políticas de privacidad'?this.GlobalInfoService.politicasPrivacidad:this.GlobalInfoService.terminosCondiciones;
    this.modalRef = this.modalService.open(this.politicasModal, { size: 'lg', centered: true });
  }

  getDataagend(){

    this._spinnerService.loading();
    this.mainHTTPService.getFilter("SGNCAAGE").subscribe(resp => {
      if (resp.isSuccessful) {
        // this.main.next(resp.result);
        this.microapps.GetMicroApplicationsById(resp.result[0].microApplicationId).subscribe(resp => {
          if (resp.isSuccessful) {

            this.token = this.auth.getAuthFromLocalStorage().accessToken;
            const page: Page = {
              codProg: "Agenda",
              name: "Agenda",
              idForm: null,
              id: 453,
              url: null,
              cambiarUrl: true,
              // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
              typeForm: 'maestro',
              lisnk:null
            };
            this.removeClass('open-item');
            this._spinnerService.close();
          
              page.url=resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser';
        
              this._pageService.generarPage(page);
          }
        });
      }
      else { }
    });
  }

  getDataalertpanel(){

    this._spinnerService.loading();
    this.mainHTTPService.getFilter("SGNGEALE").subscribe(resp => {
      if (resp.isSuccessful) {
        // this.main.next(resp.result);
        this.microapps.GetMicroApplicationsById(resp.result[0].microApplicationId).subscribe(resp => {
          if (resp.isSuccessful) {

            this.token = this.auth.getAuthFromLocalStorage().accessToken;
            const page: Page = {
              codProg: "Alertas",
              name: "Alertas",
              idForm: null,
              id: 453,
              url: null,
              cambiarUrl: true,
              // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
              typeForm: 'maestro',
              lisnk:null
            };
            this.removeClass('open-item');
            this._spinnerService.close();
          
              page.url=resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser';
              this._pageService.generarPage(page);
          }
        });
      }
      else { }
    });
  }

  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }
  closeEmit() {
    this.close.emit(1);
  }
}
